export default class Header {
	constructor(container) {
		this.container = container;

		this.prevY = window.pageYOffset || 0;

		const toggle = (event) => {
			if (window.pageYOffset > this.prevY) {
				if (window.pageYOffset > this.container.offsetHeight) {
					this.container.classList.add('collapsed');
				}
			} else {
				this.container.classList.remove('collapsed');
			}

			this.prevY = window.pageYOffset;
		};

		document.addEventListener('scroll', toggle, { passive: true });
	}
}
